import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Alert,
  TextField,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

const ConfirmSignUp: React.FC = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { confirmSignUp, resendConfirmationCode } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await confirmSignUp(email, code);
      setSuccess('Votre compte a été confirmé. Vous pouvez maintenant vous connecter.');
    } catch (err) {
      setError('Erreur lors de la confirmation.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await resendConfirmationCode(email);
      setSuccess('Un nouveau code a été envoyé.');
    } catch (err) {
      setError('Erreur lors de l\'envoi du code.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', py: 4 }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'primary.main', textAlign: 'center', mb: 4 }}>
            Confirmation du compte
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Adresse email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
            <TextField
              fullWidth
              label="Code de confirmation"
              type="text"
              value={code}
              onChange={e => setCode(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
            <Button fullWidth variant="contained" type="submit" disabled={loading} sx={{ py: 1.5, mb: 2 }}>
              Confirmer
            </Button>
            <Button fullWidth variant="text" onClick={handleResend} disabled={loading}>
              Renvoyer le code
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default ConfirmSignUp; 